"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import useKeyPressEvent from "react-use/lib/useKeyPressEvent";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { ExpandedMediaToolbar } from "./MediaActionToolbar";
export function requestCenteredImageFullscreen(fullscreenTarget: HTMLImageElement) {
  const previousObjectPosition = fullscreenTarget.style.objectPosition;
  fullscreenTarget.style.objectPosition = "center";
  const restoreInlinePosition = () => {
    if (document.fullscreenElement === fullscreenTarget) {
      return;
    }
    fullscreenTarget.style.objectPosition = previousObjectPosition;
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
  };
  document.addEventListener("fullscreenchange", restoreInlinePosition);
  fullscreenTarget.requestFullscreen().catch(() => {
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
    fullscreenTarget.style.objectPosition = previousObjectPosition;
  });
}
export function ImageMediaModal(t0) {
  const $ = _c(22);
  const {
    src,
    imageRef,
    onClose,
    onOpen,
    openLabel,
    onDownload,
    isDownloading,
    onFullscreen,
    fullscreenTargetAvailable: t1
  } = t0;
  const fullscreenTargetAvailable = t1 === undefined ? true : t1;
  const [isZoomed, setIsZoomed] = useState(false);
  useKeyPressEvent("Escape", onClose);
  let t2;
  if ($[0] !== onClose) {
    t2 = <button type="button" aria-label="Close modal" onClick={onClose} className="tw-fixed tw-inset-0 tw-z-1000 tw-border-0 tw-bg-black/80 tw-p-0" />;
    $[0] = onClose;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      disabled: true
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !isZoomed;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event_2 => setIsZoomed(event_2.state.scale > 1);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== imageRef || $[5] !== src) {
    t6 = () => <div className="tw-pointer-events-none tw-fixed tw-inset-0 tw-z-[1001] tw-flex tw-items-center tw-justify-center tw-overflow-hidden"><div className="tw-pointer-events-auto tw-relative tw-flex tw-max-h-[90vh] tw-max-w-[95vw] tw-flex-col"><div className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-justify-center"><TransformComponent wrapperClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" contentClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"><img ref={imageRef} src={src} alt="Full size drop media" style={{
              pointerEvents: "auto"
            }} className="tw-max-h-[75vh] tw-max-w-full tw-object-contain lg:tw-max-h-[90vh]" /></TransformComponent></div></div></div>;
    $[4] = imageRef;
    $[5] = src;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <TransformWrapper panning={t3} limitToBounds={t4} smooth={true} onZoom={t5}>{t6}</TransformWrapper>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== fullscreenTargetAvailable || $[11] !== isDownloading || $[12] !== onClose || $[13] !== onDownload || $[14] !== onFullscreen || $[15] !== onOpen || $[16] !== openLabel) {
    t8 = <ExpandedMediaToolbar onOpen={onOpen} openLabel={openLabel} onDownload={onDownload} isDownloading={isDownloading} onFullscreen={onFullscreen} fullscreenTargetAvailable={fullscreenTargetAvailable} onClose={onClose} />;
    $[10] = fullscreenTargetAvailable;
    $[11] = isDownloading;
    $[12] = onClose;
    $[13] = onDownload;
    $[14] = onFullscreen;
    $[15] = onOpen;
    $[16] = openLabel;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t7 || $[20] !== t8) {
    t9 = createPortal(<div className="tailwind-scope tw-relative tw-z-1000 tw-cursor-default" onTouchStart={_temp} onTouchEnd={_temp2} onTouchMove={_temp3}>{t2}{t7}{t8}</div>, document.body);
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}